const EN_US = {
  'eversightDomain.title': 'Eversight',
  'eversightDomain.competitiveIntel': 'Competitive Intel',
} as const

export default EN_US
